// Phase 93 — Frontend Error Tracker.
// Globaler window.onerror + unhandledrejection handler → POST /api/client-errors.
// Client-seitig deduping (gleiche Message + Stack innerhalb 60s wird nicht erneut geschickt),
// Session-Limit (max 20 pro Sitzung), Beacon-basierter Send (überlebt Page-Unload).

const API = process.env.REACT_APP_BACKEND_URL;

// Phase 93.5 — Android/iOS Long-Press-Drag & Context-Menu Ghost verhindern.
// Wenn Kunde ein Bild oder Link 500 ms gedrückt hält, öffnet Android-Chrome das
// „Bild speichern / Link kopieren"-Menu UND zeigt eine halbtransparente Drag-Kopie,
// die dem Finger folgt. Wir fangen die Events global ab.
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const isTargetElement = (el) => {
    if (!el || !el.closest) return false;
    return !!el.closest('img, a, button, [role="button"], [data-testid="category-card"]');
  };
  // dragstart wird auf Desktop-Drag UND Android-Long-Press ausgelöst → immer canceln.
  document.addEventListener('dragstart', (e) => {
    if (isTargetElement(e.target)) e.preventDefault();
  }, { capture: true });
  // contextmenu wird auf Right-Click UND Android-Long-Press ausgelöst.
  // Wir unterdrücken es NUR für Bilder/Links — Inputs, Text-Bereiche bleiben normal.
  document.addEventListener('contextmenu', (e) => {
    if (isTargetElement(e.target)) e.preventDefault();
  }, { capture: true });
}

if (typeof window !== 'undefined' && API) {
  const SESSION_MAX = 20;
  const DEDUPE_WINDOW = 60_000;
  const state = {
    sent: 0,
    recent: new Map(), // fingerprint → timestamp
  };
  const buildKey = (message, stack) => `${message || ''}||${(stack || '').split('\n')[0]}`;
  const post = (payload) => {
    if (state.sent >= SESSION_MAX) return;
    const key = buildKey(payload.message, payload.stack);
    const now = Date.now();
    const last = state.recent.get(key);
    if (last && now - last < DEDUPE_WINDOW) return;
    state.recent.set(key, now);
    state.sent += 1;
    const body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(`${API}/api/client-errors`, blob);
      } else {
        fetch(`${API}/api/client-errors`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
        }).catch(() => { /* ignore */ });
      }
    } catch { /* ignore */ }
  };
  const commonPayload = () => ({
    url: window.location?.pathname + window.location?.search,
    user_agent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    build: process.env.REACT_APP_BUILD || '',
  });
  window.addEventListener('error', (e) => {
    // Ignore ResizeObserver benign warnings and cross-origin script errors
    const msg = e?.message || (e?.error && e.error.message) || 'unknown';
    if (/ResizeObserver loop|Script error\.?/i.test(msg)) return;
    post({
      ...commonPayload(),
      message: msg,
      stack: e?.error?.stack || '',
      line: e?.lineno,
      col: e?.colno,
      kind: 'error',
    });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    const msg = (reason && (reason.message || String(reason))) || 'unhandledrejection';
    post({
      ...commonPayload(),
      message: msg.slice(0, 500),
      stack: (reason && reason.stack) || '',
      kind: 'unhandledrejection',
    });
  });
}

export {};
